import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getUrls,
  deleteUrl,
  getUrlById,
  insertUrl,
  updateUrl,
  getUrlsFiltered,
  getUrlsFilteredReduced,
  deleteUrlList,
  getUrlsByCategoria,
  updateUrlCartel,
  getUrlsByUrlGrupo,
  getUrlsByCategoriaWithUrlGrupo,
  sortUrlsGrupoUrl,
  desasociarUrlUrlGrupo,
  asociarUrlUrlGrupo,
  getUrlAdicionales,
  updateUrlsAdicionales,
  getUrlsFotosByUrlId,
  insertUrlFoto,
  deleteUrlFoto,
  updateUrlsFotosSortItems,
  getUrlHistorialPosiciones,
  getUrlsDeleted,
  reactivarUrls,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_URLS_FILTERED(action) {
  try {
    const urlsData = yield call(getUrlsFiltered, action.payload)
    if (urlsData.ok) {
      yield put({
        type: actions.URLS_LOAD_SUCCEEDED,
        payload: urlsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar urls')
      put({
        type: actions.URLS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URLS_DELETED() {
  try {
    const urlsData = yield call(getUrlsDeleted)
    if (urlsData.ok) {
      yield put({
        type: actions.URLS_DELETED_LOAD_SUCCEEDED,
        payload: urlsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar urls')
      put({
        type: actions.URLS_DELETED_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_DELETED_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URLS_BY_CARTEL_ID_FILTERED(action) {
  try {
    const urlsData = yield call(getUrlsFiltered, action.payload)
    if (urlsData.ok) {
      yield put({
        type: actions.URLS_BY_CARTEL_ID_LOAD_SUCCEEDED,
        payload: urlsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar urls asociadas al cartel')
      put({
        type: actions.URLS_BY_CARTEL_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_BY_CARTEL_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URLS_BY_CARTEL_ID_FILTERED_REDUCED(action) {
  try {
    const urlsData = yield call(getUrlsFilteredReduced, action.payload)
    if (urlsData.ok) {
      yield put({
        type: actions.URLS_BY_CARTEL_ID_REDUCED_LOAD_SUCCEEDED,
        payload: urlsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar urls asociadas al cartel (reduced)')
      put({
        type: actions.URLS_BY_CARTEL_ID_REDUCED_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_BY_CARTEL_ID_REDUCED_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URLS() {
  try {
    const urlsData = yield call(getUrls)
    if (urlsData.ok) {
      yield put({
        type: actions.URLS_LOAD_SUCCEEDED,
        payload: urlsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar urls')
      put({
        type: actions.URLS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URLS_BY_CATEGORIA(action) {
  try {
    const urlsData = yield call(getUrlsByCategoria, action.payload)
    if (urlsData.ok) {
      yield put({
        type: actions.URLS_LOAD_BY_CATEGORIA_SUCCEEDED,
        payload: urlsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar urls')
      put({
        type: actions.URLS_LOAD_BY_CATEGORIA_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_LOAD_BY_CATEGORIA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URLS_BY_CATEGORIA_WITH_URL_GRUPO(action) {
  try {
    const urlsData = yield call(getUrlsByCategoriaWithUrlGrupo, action.payload)
    if (urlsData.ok) {
      yield put({
        type: actions.URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_SUCCEEDED,
        payload: urlsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar urls con url grupo')
      put({
        type: actions.URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URLS_BY_URL_GRUPO_ID(action) {
  try {
    const urlsData = yield call(getUrlsByUrlGrupo, action.payload)
    if (urlsData.ok) {
      yield put({
        type: actions.URLS_BY_URL_GRUPO_ID_LOAD_SUCCEEDED,
        payload: urlsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar urls por grupo')
      put({
        type: actions.URLS_BY_URL_GRUPO_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_BY_URL_GRUPO_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URL_BY_ID(action) {
  try {
    const urlData = yield call(getUrlById, action.payload)
    if (urlData.ok) {
      yield put({
        type: actions.URL_BYID_LOAD_SUCCEEDED,
        payload: urlData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar url')
      put({
        type: actions.URL_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URL_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_URL(action) {
  try {
    const urlObj = yield call(updateUrl, action.payload)
    if (urlObj.ok) {
      putMessage(messageType.SUCCESS, 'URL modificada correctamente')
      yield put({
        type: actions.URL_UPDATE_SUCCEEDED,
        payload: urlObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar URL')
      yield put({
        type: actions.URL_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar URL')
    yield all([
      put({
        type: actions.URL_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_URL_CARTEL(action) {
  try {
    const urlCartelObj = yield call(updateUrlCartel, action.payload)
    if (urlCartelObj.ok) {
      putMessage(messageType.SUCCESS, 'Relación Url cartel modificada correctamente')
      yield put({
        type: actions.URL_CARTEL_UPDATE_SUCCEEDED,
        payload: urlCartelObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar relación Url cartel')
      yield put({
        type: actions.URL_CARTEL_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar relación Url cartel')
    yield all([
      put({
        type: actions.URL_CARTEL_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_URL(action) {
  try {
    const urlObj = yield call(insertUrl, action.payload)
    if (urlObj.ok) {
      putMessage(messageType.SUCCESS, 'URL creada correctamente')
      yield put({
        type: actions.URL_INSERT_SUCCEEDED,
        payload: urlObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear URL')
      yield put({
        type: actions.URL_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear URL')
    yield all([
      put({
        type: actions.URL_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_URL(action) {
  try {
    const urlResult = yield call(deleteUrl, action.payload)
    if (urlResult.ok) {
      putMessage(messageType.SUCCESS, 'Url eliminada correctamente')
      yield put({
        type: actions.URL_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar url')
      yield put({
        type: actions.URL_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar url')
    yield all([
      put({
        type: actions.URL_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_URLS(action) {
  try {
    const urlsResult = yield call(deleteUrlList, action.payload)
    if (urlsResult.ok) {
      putMessage(messageType.SUCCESS, 'Urls eliminadas correctamente')
      yield put({
        type: actions.URLS_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar las urls')
      yield put({
        type: actions.URLS_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar las urls')
    yield all([
      put({
        type: actions.URLS_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* SORT_URLS_GRUPO_URL(action) {
  try {
    const urlObj = yield call(sortUrlsGrupoUrl, action.payload)
    if (urlObj.ok) {
      putMessage(messageType.SUCCESS, 'URLs Grupo ordenadas correctamente')
      yield put({
        type: actions.URL_GRUPO_ASOCIACION_SORT_SUCCEEDED,
        payload: urlObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al ordenar URLs grupo')
      yield put({
        type: actions.URL_GRUPO_ASOCIACION_SORT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al ordenar URLs grupo')
    yield all([
      put({
        type: actions.URL_GRUPO_ASOCIACION_SORT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DESASOCIAR_URL_URL_GRUPO(action) {
  try {
    const urlObj = yield call(desasociarUrlUrlGrupo, action.payload)
    if (urlObj.ok) {
      putMessage(messageType.SUCCESS, 'URL desasociada correctamente')
      yield put({
        type: actions.URL_GRUPO_ASOCIACION_DELETE_SUCCEEDED,
        payload: action.payload.urlId,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al desasociar URL')
      yield put({
        type: actions.URL_GRUPO_ASOCIACION_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al desasociar URL')
    yield all([
      put({
        type: actions.URL_GRUPO_ASOCIACION_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* ASOCIAR_URL_URL_GRUPO(action) {
  try {
    const urlObj = yield call(asociarUrlUrlGrupo, action.payload)
    if (urlObj.ok) {
      putMessage(messageType.SUCCESS, 'URL asociada correctamente')
      yield put({
        type: actions.URL_GRUPO_ASOCIACION_URL_SUCCEEDED,
        payload: urlObj.data,
      })
    } else {
      putMessage(
        messageType.ERROR,
        `Error al asociar URL${urlObj?.data ? `: ${urlObj.data}` : ''}`
      );
      yield put({
        type: actions.URL_GRUPO_ASOCIACION_URL_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al asociar URL')
    yield all([
      put({
        type: actions.URL_GRUPO_ASOCIACION_URL_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URLS_ADICIONALES(action) {
  try {
    const urlsAdicionalesData = yield call(getUrlAdicionales, action.payload)
    if (urlsAdicionalesData.ok) {
      yield put({
        type: actions.URLS_ADICIONALES_LOAD_SUCCEEDED,
        payload: urlsAdicionalesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar urls adicionales')
      put({
        type: actions.URLS_ADICIONALES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_ADICIONALES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_URLS_ADICIONALES(action) {
  try {
    const urlsAdicObj = yield call(updateUrlsAdicionales, action.payload)
    if (urlsAdicObj.ok) {
      putMessage(messageType.SUCCESS, 'Urls adicionales modificada correctamente')
      yield put({
        type: actions.URLS_ADICIONALES_UPDATE_SUCCEEDED,
        payload: urlsAdicObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Urls adicionales')
      yield put({
        type: actions.URLS_ADICIONALES_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Urls adicionales')
    yield all([
      put({
        type: actions.URLS_ADICIONALES_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URLS_FOTOS(action) {
  try {
    const urlsData = yield call(getUrlsFotosByUrlId, action.payload)
    if (urlsData.ok) {
      yield put({
        type: actions.URLS_FOTOS_BY_URL_ID_LOAD_SUCCEEDED,
        payload: urlsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar urls fotos')
      put({
        type: actions.URLS_FOTOS_BY_URL_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_FOTOS_BY_URL_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_URL_FOTO(action) {
  try {
    const urlObj = yield call(insertUrlFoto, action.payload)
    if (urlObj.ok) {
      putMessage(messageType.SUCCESS, 'URL Foto creada correctamente')
      yield put({
        type: actions.URLS_FOTOS_INSERT_SUCCEEDED,
        payload: urlObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear URL Foto')
      yield put({
        type: actions.URLS_FOTOS_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear URL Foto')
    yield all([
      put({
        type: actions.URLS_FOTOS_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_URL_FOTO(action) {
  try {
    const urlsResult = yield call(deleteUrlFoto, action.payload)
    if (urlsResult.ok) {
      putMessage(messageType.SUCCESS, 'Url foto eliminada correctamente')
      yield put({
        type: actions.URLS_FOTOS_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Url foto')
      yield put({
        type: actions.URLS_FOTOS_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Url foto')
    yield all([
      put({
        type: actions.URLS_FOTOS_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_URLS_FOTOS_SORT_ITEMS(action) {
  try {
    const urlsFotosObj = yield call(updateUrlsFotosSortItems, action.payload)
    if (urlsFotosObj.ok) {
      putMessage(messageType.SUCCESS, 'Orden de Url Fotos modificado correctamente')
      yield put({
        type: actions.URLS_FOTOS_SORT_ITEMS_UPDATE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el Orden de Url Fotos')
      yield put({
        type: actions.URLS_FOTOS_SORT_ITEMS_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el Orden de Url Fotos')
    yield all([
      put({
        type: actions.URLS_FOTOS_SORT_ITEMS_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URLS_HISTORIAL_POSICIONES(action) {
  try {
    const urlsData = yield call(getUrlHistorialPosiciones, action.payload)
    if (urlsData.ok) {
      yield put({
        type: actions.URLS_HISTORIAL_POSICIONES_SUCCEEDED,
        payload: urlsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar el historial de posiciones')
      put({
        type: actions.URLS_HISTORIAL_POSICIONES_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URLS_HISTORIAL_POSICIONES_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* REACTIVAR_URLS(action) {
  try {
    const urlsFotosObj = yield call(reactivarUrls, action.payload)
    if (urlsFotosObj.ok) {
      putMessage(messageType.SUCCESS, 'URLs reactivadas correctamente')
      yield put({
        type: actions.URL_RECUPERAR_URLS_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al reactivar URLs')
      yield put({
        type: actions.URL_RECUPERAR_URLS_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al reactivar URLs')
    yield all([
      put({
        type: actions.URL_RECUPERAR_URLS_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.URLS_LOAD_REQUESTED, GET_URLS),
    takeEvery(actions.URLS_LOAD_BY_CATEGORIA_REQUESTED, GET_URLS_BY_CATEGORIA),
    takeEvery(
      actions.URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_REQUESTED,
      GET_URLS_BY_CATEGORIA_WITH_URL_GRUPO,
    ),
    takeEvery(actions.URLS_LOAD_FILTERED_REQUESTED, GET_URLS_FILTERED),
    takeEvery(actions.URL_BYID_LOAD_REQUESTED, GET_URL_BY_ID),
    takeEvery(actions.URL_UPDATE_REQUESTED, UPDATE_URL),
    takeEvery(actions.URL_INSERT_REQUESTED, INSERT_URL),
    takeEvery(actions.URL_DELETE_REQUESTED, DELETE_URL),
    takeEvery(actions.URLS_DELETE_REQUESTED, DELETE_URLS),
    takeEvery(actions.URLS_BY_CARTEL_ID_LOAD_REQUESTED, GET_URLS_BY_CARTEL_ID_FILTERED),
    takeEvery(actions.URLS_BY_CARTEL_ID_REDUCED_LOAD_REQUESTED, GET_URLS_BY_CARTEL_ID_FILTERED_REDUCED),
    takeEvery(actions.URL_CARTEL_UPDATE_REQUESTED, UPDATE_URL_CARTEL),
    takeEvery(actions.URLS_BY_URL_GRUPO_ID_LOAD_REQUESTED, GET_URLS_BY_URL_GRUPO_ID),
    takeEvery(actions.URL_GRUPO_ASOCIACION_SORT_REQUESTED, SORT_URLS_GRUPO_URL),
    takeEvery(actions.URL_GRUPO_ASOCIACION_DELETE_REQUESTED, DESASOCIAR_URL_URL_GRUPO),
    takeEvery(actions.URL_GRUPO_ASOCIACION_URL_REQUESTED, ASOCIAR_URL_URL_GRUPO),
    takeEvery(actions.URLS_ADICIONALES_LOAD_REQUESTED, GET_URLS_ADICIONALES),
    takeEvery(actions.URLS_ADICIONALES_UPDATE_REQUESTED, UPDATE_URLS_ADICIONALES),
    takeEvery(actions.URLS_FOTOS_BY_URL_ID_LOAD_REQUESTED, GET_URLS_FOTOS),
    takeEvery(actions.URLS_FOTOS_INSERT_REQUESTED, INSERT_URL_FOTO),
    takeEvery(actions.URLS_FOTOS_DELETE_REQUESTED, DELETE_URL_FOTO),
    takeEvery(actions.URLS_FOTOS_SORT_ITEMS_UPDATE_REQUESTED, UPDATE_URLS_FOTOS_SORT_ITEMS),
    takeEvery(actions.URLS_HISTORIAL_POSICIONES_REQUESTED, GET_URLS_HISTORIAL_POSICIONES),
    takeEvery(actions.URLS_DELETED_LOAD_REQUESTED, GET_URLS_DELETED),
    takeEvery(actions.URL_RECUPERAR_URLS_REQUESTED, REACTIVAR_URLS),
  ])
}
